module.exports = __webpack_public_path__ + "static/media/ny.43de02d2.hdr";